export class AnalyticsEvents {
  static readonly Login = {
    RenderedLoginPage: "login rendered page",
  };

  static readonly CreateModel = {
    AddedTrainingImage: "create model added training image",

    DeletedTrainingImage: "create model deleted training image",
    DeletedAllTrainingImages: "create model deleted all training images",
    UpdatedTrainingImageDescription:
      "create model updated training image description",

    TrainingQueued: "create model started training",

    TrainingImageBackgroundRemoved:
      "create model removed training image background",
    AllTrainingImagesBackgroundRemoved:
      "create model removed all training images background",
  };

  static readonly Navigation = {
    ClickedHome: "navigation clicked home",
    ClickedHomeLogo: "navigation clicked home logo",

    ClickedOrganizationDropdown: "navigation clicked organization dropdown",
    ClickedOrganizationSettings: "navigation clicked organization settings",
    ClickedCreateOrganization: "navigation clicked create organization",

    ClickedProjectDropdown: "navigation clicked project dropdown",
    ClickedProjectSettings: "navigation clicked project settings",
    ClickedCreateProject: "navigation clicked create project",

    /**
     * Tools are accessible from two different contexts:
     *
     * 1. From the home page, when the user lands on https://app.scenario.com
     * 2. From the "Create" menu in the navigation bar, when the user clicks on "Create" and select
     *    one of the tools
     */
    ClickedModelTrain: "navigation clicked model train",
    ClickedModelCompose: "navigation clicked model compose",
    ClickedModelUpload: "navigation clicked model upload",

    ClickedGenerateImages: "navigation clicked generate images",
    ClickedGenerateVideo: "navigation clicked generate video",
    ClickedGenerateTextures: "navigation clicked generate textures",
    ClickedGenerate3D: "navigation clicked generate 3d",
    ClickedGenerateSkyboxes: "navigation clicked generate skyboxes",
    ClickedGenerateLive: "navigation clicked generate live",

    ClickedEditReframe: "navigation clicked edit reframe",
    ClickedEditVectorize: "navigation clicked edit vectorize",
    ClickedEditWithPrompt: "navigation clicked edit with prompt",
    ClickedEditPixelate: "navigation clicked edit pixelate",
    ClickedEditRemoveBackground: "navigation clicked edit remove background",
    ClickedEditRestyle: "navigation clicked edit restyle",
    ClickedEditEnhance: "navigation clicked edit enhance",
    ClickedEditRetouch: "navigation clicked edit retouch",

    /** Only applicable from the home page */
    ClickedViewAllToolsDisplayAll:
      "home tools clicked view all tools display all",
    ClickedViewAllToolsMinimized: "home tools clicked view all tools minimized",

    /**
     * Assets, only available when authenticated
     */
    ClickedAssets: "navigation clicked assets",
    /**
     * Do not exist as of now, one must go through "Assets"
     *
     * @TODO to be discussed
     */
    ClickedModels: "navigation clicked models",

    ClickedExplore: "navigation clicked explore",
    /**
     * could have been ClickedHelpCenter: "navigation clicked help center",
     */
    ClickedHelpCenter: "navigation clicked help center",

    ClickedSearch: "navigation clicked search",
    /**
     * Could have been named "ClickedJobsCenter"
     */
    ClickedNotifications: "navigation clicked notifications",
    ClickedNotificationsViewAll: "navigation clicked notifications view all",
    ClickedCollections: "navigation clicked collections",

    ClickedUpgrade: "navigation clicked upgrade",
    ClickedSpeedUpProcessing: "navigation clicked speed up processing",
    ClickedSubscriptionEndingSoon:
      "navigation clicked subscription ending soon",
    ClickedTrustCenter: "navigation clicked trust center",
    ClickedChat: "navigation clicked chat",
    ClickedReferral: "navigation clicked referral",
    ClickedFeatureRequest: "navigation clicked feature request",
    ClickedFeedback: "navigation clicked feedback",
    ClickedWhatsNew: "navigation clicked whats new",
    ClickedShortcuts: "navigation clicked shortcuts",
    ClickedSupport: "navigation clicked support",
    ClickedLogout: "navigation clicked logout",
    ClickedProfile: "navigation clicked profile",
    ClickedUnity: "navigation clicked unity",

    /**
     * The following group concerns assets' type tab navigation.
     */
    ClickedSelectImages: "navigation clicked select images",
    ClickedSelectModels: "navigation clicked select models",
    ClickedSelectVideos: "navigation clicked select videos",
    ClickedSelect3D: "navigation clicked select 3d",
    ClickedSelectTextures: "navigation clicked select textures",
    ClickedSelectSkyboxes: "navigation clicked select skyboxes",
    ClickedSelectCanvas: "navigation clicked select canvas",
  };

  static readonly HomeCarousel = {
    /**
     * Clicked Carousel Card is the event triggered when the user click one of the cards. This event
     * is associated with the following properties:
     * - `persona`, // persona that led to the card display
     * - `cardSlug`, // unique slug, example: "render-sketches"
     * - `cardTitle`, // title of the card, example: "Render Sketches"
     * - `cardPosition`, // position in the carousel, example: 3
     * - `cardTag`, // tag of the card, example: "Tool"
     * - `mediaType`, // image or video
     * - `mediaUrl`, // url of the media, example: "/home/highlights/all_in_one_380.jpg"
     * - `ctaLabel`, // label of the CTA button, example: "Generate Now"
     */
    ClickedCarouselCardCTA: "home carousel clicked carousel card cta",
    ClickedCarouselNavigation: "home carousel clicked carousel navigation",
  };

  /**
   * This ensemble of events concerns the explore page, which is accessible from two different
   * contexts:
   *
   * 1. From the home page, when the user lands on https://app.scenario.com
   * 2. From the explore page, when the user clicks on "Explore" in the navigation bar, page
   *    `/explore`
   */
  static readonly Explore = {
    /** Only applicable from the home view */
    ClickedViewAll: "home explore clicked view all",

    /**
     * This event is triggered when a user clicks on an asset in the explore page or from the home page.
     *
     * It comes with the property `level`, which is the level of the click.
     */
    ClickedAsset: "explore clicked asset",
    ClickedBack: "explore clicked back",

    /**
     * The following group is applicable only from the home view.
     */
    ClickedGenerateNow: "home explore clicked generate now",
    ClickedOpenExplore: "home explore clicked open explore",
  };

  static readonly Library = {
    // Keeping the group as we will add more events here.
  };

  static readonly Model = {
    Copied: "model copied",
    Deleted: "model deleted",
    Exported: "model exported",
    CopiedTrained: "model copied trained",
    UploadedThumbnail: "model uploaded thumbnail",
    Uploaded: "model uploaded",
    UsedDeprecatedGeneratorId: "model used deprecated generator id",
    UsedDeprecatedGeneratorRoute: "model used deprecated generator route",
  };

  static readonly Inference = {
    SelectedModel: "generate inference selected model",
    CreatedInference: "generate inference created inference",
    ImportedReferenceImage: "generate inference imported reference image",
    ImportedIpAdapterImage: "generate inference imported ip adapter image",
    UsedDeprecatedImportAssetId:
      "generate inference used deprecated import asset id",
    ImportedSecondReferenceImage:
      "generate inference imported second reference image",
  };

  static readonly ImageLibrary = {
    RemovedBackground: "asset removed background",
    UpscaledImage: "asset upscaled",
    DownloadedImage: "asset downloaded",
    PixelatedImage: "asset pixelated",
    DeletedImage: "asset deleted",
    UploadedImage: "asset uploaded",
    VectorizedImage: "asset vectorized",
    PromptEditedImage: "asset edited by prompt",
  };

  static readonly Signup = {
    ReferralCaptured: "signup referral captured",

    /**
     * Followings refer to the signup modal, which is displayed when a user is not authenticated.
     */
    ModalDisplayed: "signup modal displayed",
    ModalCTAClicked: "signup modal cta clicked",
    ModalDismissed: "signup modal dismissed",
  };

  static readonly User = {
    PolicyAccepted: "user policy accepted",
    Onboarded: "user onboarded",
    accountDeleted: "user account deleted",
  };

  static readonly Canvas = {
    DrawMask: "canvas draw mask",
    Sketch: "canvas sketch",
    Downloaded: "canvas downloaded",
    NewCanvasCreated: "canvas created",
    UndoTriggered: "canvas undo",
    RedoTriggered: "canvas redo",
    CreatedInference: "canvas created inference",
    Deleted: "canvas deleted",
    DisplayLockModal: "canvas display lock modal",
    Draw: "canvas draw",
    Duplicate: "canvas duplicated",
    ForceUnlock: "canvas forced unlock",
    ImportedFromGallery: "canvas imported from gallery",
    OpenSection: "canvas opened section",
    RemoveBackground: "canvas removed background",
    Upload: "canvas uploaded",
    Upscale: "canvas upscaled",

    LiveToggle: "canvas toggled live",
    SeedClick: "canvas clicked seed",
    OpenedSetting: "canvas opened setting",
    SendOutputToInput: "canvas sent output to input",
  };

  static readonly Gallery = {
    ChangeGridView: "gallery changed view",
    ChangeColumnsNumber: "gallery changed columns number",
  };

  static readonly Team = {
    CreatedTeam: "team created",
    DeletedTeam: "team deleted",
    AddedMember: "team added member",
    RemovedMember: "team removed member",
    CreatedApiKey: "team created api key",
    DeletedApiKey: "team deleted api key",
    LeftTeam: "team member left",
    RemovedPendingMember: "team removed pending member",
  };

  static readonly Project = {
    CreatedProject: "project created",
    DeletedProject: "project deleted",
    AddedMember: "project added member",
    RemovedMember: "project removed member",
    LeftProject: "project member left",
    RemovedPendingMember: "project removed pending member",
  };

  static readonly Subscription = {
    RedirectedToPaymentPage: "subscription redirected to payment page",
    CancelledPlan: "subscription cancelled plan",
    UpgradedPlan: "subscription upgraded plan",
    DowngradedPlan: "subscription downgraded plan",
    ReactivatedPlan: "subscription reactivated plan",
    AddedSeats: "subscription added seats",
    RemovedSeats: "subscription removed seats",
  };

  static readonly Oscu = {
    RedirectedToPaymentPage: "oscu redirected to payment page",
  };

  static readonly Search = {
    Searched: "search searched",
    ImportedImage: "search imported image",
  };

  static readonly AssetZoom = {
    UsedDeprecatedOpenAssetId: "asset zoom used deprecated open asset id",
    CreatePreset: "asset zoom created preset",
    Downloaded: "asset zoom downloaded",
  };

  static readonly Pixelate = {
    ImportedReferenceImage: "pixelate imported reference image",
  };

  static readonly Upscale = {
    ImportedReferenceImage: "upscale imported reference image",
  };

  static readonly RemoveBackground = {
    ImportedReferenceImage: "remove background imported reference image",
  };

  static readonly Vectorize = {
    ImportedReferenceImage: "vectorize imported reference image",
  };

  static readonly Skybox = {
    ImportedReferenceImage: "skybox imported reference image",
    GeneratedSkyboxes: "skybox created inference",
    UpscaledSkybox: "skybox upscaled",
  };

  static readonly SkyboxUpscale = {
    ImportedStyleImage: "skybox upscale imported style image",
  };

  static readonly Restyle = {
    CreatedInference: "restyle created inference",
    ImportedReferenceImage: "restyle imported reference image",
    ImportedStyleImage: "restyle imported style image",
  };

  static readonly PromptEdit = {
    ImportedReferenceImage: "prompt edit imported reference image",
    ImportedContextImages: "prompt edit imported context images",
  };

  static readonly Blend = {
    Tested: "compose tested",
    Created: "compose created",
  };

  static readonly TourGuide = {
    OpenedTutorial: "tour guide opened tutorial",
    ClosedTutorial: "tour guide closed tutorial",
    OpenedPage: "tour guide opened page",
    ClosedPage: "tour guide closed page",
    ClickedLearnMore: "tour guide clicked learn more",
  };

  static readonly Reframe = {
    GeneratedReframe: "reframe created inference",
    ImportedReferenceImage: "reframe imported reference image",
  };

  static readonly DataDeletion = {
    ClickedTopBarDataDeletion: "data deletion clicked top bar data deletion",
    ClickedAssetDataDeletion: "data deletion clicked asset data deletion",
    ClickedCanvasDataDeletion: "data deletion clicked canvas data deletion",
  };

  static readonly CardAction = {
    ReloadedParameters: "card action reloaded parameters",
    ReusedModel: "card action reused model",
    ReusedImage: "card action reused image",
    ReusedPrompt: "card action reused prompt",
    ReusedSeed: "card action reused seed",
    ClickedUpscale: "card action clicked upscale",
    ClickedRetouch: "card action clicked retouch",
    ClickedLive: "card action clicked live",
    ClickedMore: "card action clicked more",
    ClickedSearchSimilar: "card action clicked search similar",
    ClickedExpand: "card action clicked expand",
    ClickedPromptEdit: "card action clicked prompt edit",
    ClickedConvertTo3D: "card action clicked convert to 3d",
    ClickedConvertToVideo: "card action clicked convert to video",
    ClickedDownload: "card action clicked download",
    ClickedDelete: "card action clicked delete",
  };

  static readonly Custom = {
    ImportedReferenceImage: "custom imported reference image",
  };

  static readonly Collection = {
    Deleted: "collection deleted",
  };

  static readonly Footer = {
    ClickedLink: "footer clicked link",
  };
}
